<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <blockquote style="margin:0 0 0 40px;border:none;padding:0px;">
        <p v-html="text.profile6"></p>
      </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: {
        profile6:
          "<br />北京马可泰克国际科技发展有限公司（下称“北京马可国际”）成立于2003年，其前身是成立于1996年的美国马可集团北京代表处，系美国马可国际集团和美国环球冶金股份有限公司在华业务总代理。<br /><br />美国马可国际集团公司是一家集国际贸易、 国际投资为一体的集团公司， 总部位于美国纽约曼哈顿， 分支机构遍布于全球。 作为一个专业的贸易集团， 公司业务涉及有色金属、 黑色金属、 矿产、 化工以及保健原料、 医药原料、 食品原料等众多领域， 几十个品种， 部分品种已成为国际贸易的引领者。 自上世纪九十年代初， 公司便积极开张在中国的业务， 与中信集团、 中国医保、 中国有色、 中国五矿、 中铝集团、 洛铜集团、 江西铜业集团等国内著名企业都建立了长期的贸易往来， 对华贸易持续增长， 目前， 中国已经成为公司主要的业务板块之一。<br /><br />投资实体， 是集团另一主要发展方向。 自上世纪末开始， 集团就开始在全球范围内寻购著名的大型企业， 先后购买了中东欧最大铝厂罗马尼亚铝厂(Alro)、 全北美最大的铸造合金生产企业美国环球冶金有限公司(Globe Metallurgical Inc)， 美国大型特种铝管制造企业阿拉巴马铝管厂以及其他著名的金属加工企业。<br /><br />在医药食品领域， 集团与美国著名的药厂 Hi - Tech Pharmacia Co.,Inc 合作， 共同开发研制药品、 保健品。 Hi - Tech Pharmacia Co.,Inc 是美国一家专业生产药品的上市公司， 以试剂药闻名。 与 Hi - Tech Pharmacia Co.,Inc 成立了合资公司 Marco Hi - Tech， 专门负责全球采购药品、 保健品和食品原料。<br /><br />美国环球冶金股份有限公司是全球最大的金属硅和硅系特种合金的生产商， 主要生产各种被广泛地应用于需求日益增长的工业领域和日用消费领域的特殊规格硅系合金。 公司是纽约纳斯达克交易所上市公司（ 股票代码： GSM） 集团总部位于纽约曼哈顿中心区， 在美国俄亥俄州、 西弗吉尼亚州、 阿拉巴马州、 纽约州以及在南美、 东欧等都建有分厂或子公司。 宁夏永威炭业公司是其专门打造的高品质电极制造商。"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus' scoped>
</style>


// WEBPACK FOOTER //
// src/components/zh/profile/gsjj.vue